import { platformBrowser } from '@angular/platform-browser'
import { environment } from '@envs/environment'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { AppModule } from '@app/app.module'
import { RUNTIME_CONFIG, loadRuntimeConfig } from '@config/runtime-config'
import { showAppPreloaderError } from '@services/app-preloader.service'

if (environment.production) {
	enableProdMode()

	if (typeof window !== 'undefined') {
		window.console.debug = () => {}
		window.console.log = () => {}
		window.console.info = () => {}
		window.console.warn = () => {}
	}
}

// O agente do New Relic troca o Promise global pelo wrapper de instrumentação dele. Se isso
// acontecer antes do bootstrap, o Zone.js aborta com "ZoneAwarePromise has been overwritten".
// Como o boot agora espera o runtime config (loadRuntimeConfig, abaixo), a ordem deixou de ser
// garantida por um simples `defer` — carregar o agente só depois do bootstrap resolver torna a
// sequência determinística (mesmo incidente já visto em produção no portal-frontend, ver
// specs/027-secrets-cloudfront-runtime-config/plan.md).
function loadNewRelic() {
	if (typeof document === 'undefined') return
	const newRelicScript = document.createElement('script')
	newRelicScript.src = 'assets/js/newrelic.js'
	newRelicScript.defer = true
	document.head.appendChild(newRelicScript)
}

// As chaves de APIs externas (Google Maps, Firebase) são resolvidas antes do bootstrap para que
// o AppModule e os serviços possam injetá-las via RUNTIME_CONFIG sem que precisem existir no bundle.
loadRuntimeConfig()
	.then(runtimeConfig =>
		platformBrowser([{ provide: RUNTIME_CONFIG, useValue: runtimeConfig }]).bootstrapModule(AppModule, {
			applicationProviders: [provideZoneChangeDetection()]
		})
	)
	.then(() => {
		if (environment.production) loadNewRelic()
	})
	.catch(err => {
		console.error(err)
		// Sem a primeira tela, o preloader do index.html é tudo o que o usuário vê: avisa e oferece
		// recarregar, em vez de girar para sempre.
		if (typeof document !== 'undefined') showAppPreloaderError(document)
	})
